<template>
    <div>
        <template v-if="getSingleStudentGrades">
            <b-table
                hover
                responsive
                striped
                :items="getSingleStudentGrades"
                :fields="gradeFields"
            >
                <template v-slot:cell()="data">
                    <!-- This template allows to display a Bold Total row -->
                    <strong v-if="data.item.id === -1">{{ data.value }}</strong>
                    <span v-else>{{ data.value }}</span>
                </template>
            </b-table>
        </template>
        <h5 v-else class="pt-4">
            No existe ninguna evaluación para este sitio web.
        </h5>

    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'SingleStudentGrades',
    data () {
        return {
            gradeFields: [
                { key: 'name', label: 'Evaluación' },
                { key: 'percentage', label: 'Porcentaje (%)' },
                { key: 'grade', label: 'Nota' }
            ]
        }
    },
    computed: {
        ...mapState([
            'activeSite'
        ]),
        ...mapGetters([
            'getSingleStudentGrades'
        ])
    }
}
</script>
